exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".wg-news__card{cursor:pointer}.wg-news__title{color:#0075a8;font-size:14px !important}", "", {"version":3,"sources":["/home/webuser/kmp3/releases/176/spa/src/components/widget-news/WidgetNews.vue"],"names":[],"mappings":"AAII,eACE,cAAA,CAEF,gBACE,cACA,yBAAA,CAAA","file":"WidgetNews.vue?vue&type=style&index=0&id=4d51d6d4&prod&lang=scss","sourcesContent":["\n@use '../../assets/scss/variables';\n\n  .wg-news {\n    &__card {\n      cursor: pointer;\n    }\n    &__title {\n      color: variables.$wn-title-color;\n      font-size: 14px!important;\n    }\n  }\n"],"sourceRoot":""}]);

// exports
